<template>
    <transition name="el-fade-in-linear">
        <div class="mask" v-show="state">
            <div class="main">
                <img src="@/static/register_popup.png" alt="" class="main_left">
                <div class="form">
                    <div class="form_close el-icon-close" @click="hide()"></div>
                    <img src="@/static/logo-03.png" alt="" class="form_logo">
                    <div class="form_title">1分钟注册 立即选品</div>
                    <div class="form_item">
                        <el-input class="form_item_input" v-model="formData.mobile" maxlength="11" placeholder="请输入手机号码"></el-input>
                    </div>
                    <div class="form_item">
                        <el-input class="form_item_input" v-model="formData.code" maxlength="6" placeholder="请输验证码">
                            <el-button class="sendbut" slot="suffix" :style="{'background-color':second>0?'#909399':'#5574E8'}" @click.stop="sendCode">{{second>0?`${second}秒后发送`:'发送验证码'}}</el-button>
                        </el-input>
                    </div>
                    <div class="form_item">
                        <el-input class="form_item_input" v-model="formData.pwd" placeholder="密码[必须包含大小写字母数字特殊字符(1@#$%^&*0_+)]" show-password></el-input>
                    </div>
                    <el-button :loading="submitLoad" style="width: 100%;" @click="onSubmit">立即注册</el-button>
                    <div class="form_tip">新用户注册立得<span>200元</span>采购金</div>
                    <div class="form_footer"><a href="/manager/login/index">已有账号，直接登录></a></div>
                </div>
            </div>
        </div>
      </transition>
</template>
<script>
let T;
import { loginRegion,send} from "@/api/common";
import {mapState} from 'vuex'
export default {
    name:'ys-register-popup',
   data(){
    return {
        state : false,
        formData : {
            mobile : '',
            code : '',
            pwd : '',
            defaultLogin : 1,//是否注册完自动登录 0否 1是
        },
        timer : null,
        second : 0,
        submitLoad :false,
        paramObj : {}
    }
   },
   watch:{
    sysInfo:{
        deep: true,
        handler(){
            this.bindInterval();
        }
    },
   },
   computed:{
        ...mapState(['sysInfo']),
        isMobile(){
            return (new RegExp(/^1[3-9]\d{9}$/)).test(this.formData.mobile) ? true : false
        }
   },
   mounted(){
        this.$bus.$on('registerPopup',res=>{
            this.state = true;
        })
        this.paramObj = {...this.$route.params,...this.$route.query}
        if(this.paramObj.source){
            localStorage.setItem('@ys_promotion_source',this.paramObj.source)
        }
        this.bindInterval();
   },
   methods:{
        bindInterval(){
            clearInterval(T)
            if(this.sysInfo.sys_id==11 && this.sysInfo.register_up_time && localStorage.getItem('@ys_promotion_source')){
                T = setInterval(()=>{
                    this.state = true;
                },this.sysInfo.register_up_time * 1000)
            }
        },
        onSubmit(){
            let errMsg = !this.formData.mobile ? '请输入手机号码' 
            : !this.isMobile ? '请输入正确的手机号码' 
            : !this.formData.code ? '请输入短信验证码' 
            : !this.formData.pwd ? '请输入密码' : ''
            if(errMsg){
                this.$message.warning(errMsg);
            }else if(!this.submitLoad){
                try {
                    this.submitLoad = true;
                    loginRegion({...this.formData,...this.paramObj}).then(res=>{
                        this.submitLoad = false;
                        if(res.error_code===0){
                            this.formData = {
                                mobile : '',
                                code : '',
                                pwd : '',
                                defaultLogin : 1,//是否注册完自动登录 0否 1是
                            }
                            this.state = false;
                            window.location.href = '/manager/index/index';
                            // setTimeout(()=>{
                            //     this.$message.success('注册成功');
                            // },500)
                        }
                    })
                } catch (error) {
                    this.submitLoad = false;
                }
            }
        },
        hide(){
            this.state = false;
            this.bindInterval();
        },
        //发送验证码
        sendCode(){
            if(this.second==0){
                if(this.isMobile){
                    send({mobile:this.formData.mobile,type:'region'}).then(res=>{
                        if(!res.error_code){
                            this.second = 59;
                            this.timer = setInterval(()=>{
                                this.second--;
                                if(this.second<0){
                                    this.second = 0;
                                    clearInterval(this.timer);
                                }
                            },1000)
                        }
                    })
                }else{
                    this.$message.warning('请输入正确的手机号码');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.mask{
    position: fixed;
    left: 0;
    top:0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: #0000006e;
    transition: all .3s;
    display: flex;
    justify-content: center;
    align-items: center;
}
.main{
    display: flex;
    width: 808px;
    height: 498px;
    &_left{
        width: 45%;
        height: 100%;
    }
    .form{
        background-color: #fff;
        padding: 35px 25px 10px;
        border-radius:18px;
        position: relative;
        flex: 1 0 0;
        height: 100%;
        margin-left: -18px;
        text-align: center;
        &_close{
            position: absolute;
            right: 8px;
            top: 8px;
            font-size: 26px;
            color: #999;
            cursor: pointer;
        }
        &_title{
            color: #5574E8;
            font-size: 24px;
            font-weight: bold;
            margin: 16px 0 28px;
        }
        &_item{
            &_input{
                margin-bottom: 22px;
            }
        }
        &_tip{
            margin-top: 20px;
            span{
                color: #F80B21;
            }
        }
        &_footer{
            margin-top: 30px;
            a{
                color: #F80B21;
            }
        }
        &::v-deep {
            .el-input__inner{
                padding: 22px 0 22px 22px;
                font-size: 15px;
            }
            .el-button{
                background-color: #5574E8;
                border-radius: 4px;
                color: #fff;
                padding: 15px 15px;
                font-size: 16px;
                &.sendbut{
                    margin: 0 -5px 0 0;font-size:13px;
                }
            }
        }
    }
}

</style>
